import { render, staticRenderFns } from "./GalleryAddon.vue?vue&type=template&id=ac696c78"
import script from "./GalleryAddon.vue?vue&type=script&lang=ts"
export * from "./GalleryAddon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports